var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 0.00201416C4.47901 0.00201416 0.00201416 4.47901 0.00201416 10.001C0.00201416 14.991 3.65801 19.127 8.43901 19.88V12.892H5.89901V10.001H8.43901V7.79801C8.43901 5.29001 9.93201 3.90701 12.215 3.90701C13.309 3.90701 14.455 4.10201 14.455 4.10201V6.56101H13.191C11.951 6.56101 11.563 7.33301 11.563 8.12401V9.99901H14.334L13.891 12.89H11.563V19.878C16.344 19.129 20 14.992 20 10.001C20 4.47901 15.523 0.00201416 10.001 0.00201416Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLogo);
export default __webpack_public_path__ + "static/media/fb-logo.593d02409b660311a8e125bc28407de7.svg";
export { ForwardRef as ReactComponent };